<div (click)="onClick()" class="ds-radio-holder">
  <input
    tabindex="0"
    class="radio-input"
    type="radio"
    [ngModel]="selected"
    (ngModelChange)="onModelChange($event)"
    [value]="value"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onChange($event)"
  />
  <div class="ds-radio" tabindex="-1" [ngClass]="{ checked: checked, disabled: disabled, 'type-box': variant === 'box', 'has-error': hasError }">
    <div class="ds-radio-circle" [ngClass]="{ checked: checked, disabled: disabled }"></div>
    <label class="ds-radio-content">
      <p class="ds-ui-2" [ngClass]="disabled ? 'ds-color-core-neutral-5' : 'ds-color-core-neutral-10'">
        <ng-content select="[ds-radio-title]"></ng-content>
      </p>
      <p class="ds-ui-3" *ngIf="variant !== 'default'" [ngClass]="disabled ? 'ds-color-core-neutral-5' : 'ds-color-core-neutral-7'">
        <ng-content select="[ds-radio-desc]"></ng-content>
      </p>
    </label>
  </div>
  <p *ngIf="hasError && errorMessage && !checked && !disabled" class="ds-ui-3 ds-radio-error">
    {{ errorMessage }}
  </p>
</div>
